import './FiModalTopSix.scss';

import * as angular from 'angular';

import { Component } from '../Component';

@Component({
    controllerAs: 'vm',
    template: require('./FiModalTopSix.html'),
    bindings: {

    },
})
export class FiModalTopSix {
    static $inject = [
        '$mdDialog',
        '$window',
    ];


    constructor(
        private $mdDialog: angular.material.IDialogService,
        private $window: angular.IWindowService,
    ) {
        //
    }

    $onInit() {
        //
    }

    close() {
        this.$mdDialog.cancel();
    }

    goToOrder() {
        this.close();
        this.$window.location.href = '/meistro-uzsakymas';
    }

}